import { Box, Typography } from "@mui/material";
import React from "react";
import styled from "styled-components";
import SlickCarousel from "../../../SlickCarousel";
import CustomModal from "../../../Modal/CustomModal";
import CertificateModal from "../../../Modal/CertificateModal";
import CertificateCanvas from "./CerificateCanvas";
import { cookies, instance } from "../../../../Controller/Common";
import { useSelector } from "react-redux";
import { RootState } from "../../../../Redux/UserSlice";

const MyCertificate: React.FC = () => {
  const [selectedCertificate, setSelectedCertificate] = React.useState<any>({});
  const [Certification, setCertification] = React.useState<any>([]);
  const [open, setOpen] = React.useState(false);
  const userId =
    useSelector((state: RootState) => state.user.userID) ??
    cookies.get("userId");
  const userName = useSelector((state: RootState) => state.user.userName);
  const params = new URLSearchParams(window.location.search);
  const courseId = params.get("courseid");
  const popupStatus = params.get("certificatepopup");

  const getMyCertificate = async () => {
    try {
      const response = await instance.get(
        `/6D/activity/get-completed-course/${userId}`
      );
      if (response.status === 200) {
        setCertification(response.data);
        if (courseId && popupStatus) {
          const index =
            Array.isArray(response.data) && response.data.length > 0
              ? response.data?.findIndex(
                  (i: any) => i?.CID === Number(courseId)
                )
              : -1;
          const data = response.data[index];
          handleOpenModal(data);
          params.delete("courseid");
          params.delete("certificatepopup");
          window.history.replaceState(
            {},
            "",
            `${window.location.pathname}?${params}`
          );
        }
      }
    } catch (error) {
      console.error("Failed to get certificate list:", error);
    }
  };

  const carouselSettings = (() => {
    const courseCount = Certification.length;

    if (courseCount <= 4) {
      return {
        slidesToShow: courseCount,
        slidesToScroll: courseCount,
        centerMode: courseCount % 2 !== 0,
        centerPadding: courseCount === 1 ? "0px" : "50px",
      };
    }

    return {
      slidesToShow: 4,
      slidesToScroll: 1,
      centerMode: false,
      centerPadding: "50px",
    };
  })();

  const handleOpenModal = (item: any) => {
    setOpen(true);
    setSelectedCertificate(item);
  };

  const handleClose = () => {
    setOpen(false);
  };

  React.useEffect(() => {
    getMyCertificate();
  }, []);

  return (
    <>
      {Array.isArray(Certification) && Certification.length > 0 ? (
        <BorderBox>
         <Typography className="Activity" style={{fontSize: "14px", fontWeight:"500"}}>My Certificates</Typography>
          <SlickCarousel {...carouselSettings} left={true}>
            {Certification?.map((item: any, index: number) => (
              <Box
                key={index}
                sx={{
                  mr: "auto",
                  ml: "auto",
                  display: "flex",
                  justifyContent: "left",
                  flexDirection: "column",
                  padding: "0px 20px 0px 20px",
                  cursor: "pointer",
                }}
                onClick={() => handleOpenModal(item)}
              >
                <CertificateCanvas
                  courseName={item.TITLE}
                  name={userName}
                  date={item.updatedAt}
                  certificateId={item.UCID}
                />
                <Typography
                  sx={{
                    fontWeight: 400,
                    fontSize: "11px",
                    color: "#3F3F40",
                    textAlign: "center",
                    pt: "10px",
                  }}
                >
                  {item.TITLE}
                </Typography>
              </Box>
            ))}
          </SlickCarousel>
        </BorderBox>
      ) : null}
      <CustomModal
        open={open}
        handleClose={handleClose}
        sx={{ height: "auto", mt: 5 }}
        child={
          <CertificateModal
            setOpen={setOpen}
            certificate={selectedCertificate}
          />
        }
      />
    </>
  );
};

export default MyCertificate;

const BorderBox = styled(Box)`
  display: flex;
  width: 100%;
  border: 2px solid white;
  flex-direction: column;
  border-radius: 3px;
  padding: 8px;
  margin-bottom: 30px;
`;
